import self from "../img/self.png"
import mock1 from "../img/tfproject.png"
import mock2 from "../img/trybetunes.png"
import mock3 from "../img/mock3.png"
import mock4 from "../img/mock4.png"
import mock5 from "../img/mock5.png"
import planet from "../img/planets-project.png";
import wallet from '../img/trybe-wallet-project.png';
import triviaImg from '../img/trivia-game-2.png'
import tryunfoImg from '../img/tryufo-project.png'
import trybeTunes from '../img/trybe-tunes.png';
import trybeOnlineStore from '../img/trybe-online-store.png';
import recipeApp from '../img/recipeApp.png';
import pixelArt from '../img/pixel-art-project.png';
import coletivoIa from "../img/coletivoia.png"
import road2gold from "../img/roag2goldTech.png"
import nuflow from "../img/nuflow.png"
import greenriver from "../img/greenriver.png"
import cgl from "../img/cglfundacoes.png"
import marcam from "../img/marcam.png"
import artepoxy from "../img/artepoxy.png"
import blt from "../img/blthides.png"
import giveback from "../img/giveback.png"
import headstart from "../img/headstart.png"
import beactive from "../img/beactive.png"
import fundit from "../img/fundit.png"
import bembos from "../img/bembos.png"

import {html, css, js, react, redux, docker, mysql,
    nodejs, sequelize, JWT, heroku, typescript, jest, mocha, api, python, mongoDb, nextjs, wordpress} from '../img/icons/index'
import { Api, Javascript } from "@mui/icons-material"


/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(161,158,158)", "rgb(61,57,57)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */


/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
    firstName: "Humberto",
    lastName: "Dutra",
    initials: "hd", // the example uses first and last, but feel free to use three or more if you like.
    position: "a Full Stack Developer",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
    miniBio: [ // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
        {
            emoji: '☕',
            text: 'coffe and code'
        },
        {
            emoji: '🌎',
            text: 'based in the Brazil'
        },
        {
            emoji: "💼",
            text: "Full Stack Developer"
        },
        {
            emoji: "📧",
            text: "humbertodutra.dev@gmail.com"
        }
    ],

    socials: [
        {
            link: "https://github.com/humbertodutra",
            icon: "fa fa-github",
            label: 'github'
        },
        {
            link: "https://www.linkedin.com/in/humberto-dvslima/",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        }
    
      
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
  
    bio: "Hello! I'm Humberto, a Full Stack Developer with 4+ years building and shipping web and mobile applications for international clients. Currently at LexArt Labs, I work across Israel and LATAM with a modern stack: TypeScript, React/React Native, Node.js and Python. My focus is AI engineering — integrating LLMs like the Claude API into production, from RAG pipelines to conversational agents. A law degree and four years in law firms give me real fluency in legal workflows, making me a strong fit for legaltech and any domain where understanding the problem matters as much as writing the code.",
    skills:
        {
            proficientWith: ['TypeScript', 'React', 'React Native', 'Expo', 'Next.js', 'Node.js', 'Python', 'Claude API', 'RAG', 'PostgreSQL', 'Supabase', 'MongoDB', 'Docker', 'GCP'],
            exposedTo: []
        }
    ,
    hobbies: [
        {
            label: 'read',
            emoji: '📖'
        },
        {
            label: 'travel',
            emoji: '✈️'
        },
        {
            label: 'movies',
            emoji: '🎥'
        },
        {
            label: 'cook',
            emoji: '🍳'
        },
        {
            label: 'football/soccer',
            emoji: '⚽'
        },
        {
            label: 'swim',
            emoji: '🏊‍♂️'
        },
        {
            label: 'meditation',
            emoji: '🧘‍♂️'
        }

    ],
    portfolioPro: [
        {
            title: "NuFlow",
            live: "https://market.nuflow.com.br/",
            source: "https://github.com/humbertodutra/trybe-project-trivia/",
            image: nuflow,
            stack: [react, mysql, api],
        },
        {
            title: "CGL Fundacoes",
            live: "https://cglfundacoes.com.br/",
            source: "https://github.com/humbertodutra/trybe-tunes",
            image: cgl,
            stack: [wordpress],
        },
        {
            title: "Marcam Industrial",
            live: "https://marcamindustrial.com.br/",
            source: "https://github.com/humbertodutra/trybe-online-store-17/",
            image: marcam,
            stack: [wordpress],
        },
        {
            title: "BLT Hides",
            live: "https://blthides.com.br/home-pt-br/",
            source: "https://github.com/humbertodutra/trybe-project-recipes-app",
            image:  blt,
            stack: [wordpress],
        },
        {
            title: "Art Epoxy Desings",
            live: "https://artepoxydesigns.com/",
            source: "https://github.com/humbertodutra/trybe-pixel-art/",
            image: artepoxy,
            stack: [wordpress],
        },
        {
            title: "road2gold Crypto Bot",
            live: "https://www.road2gold.tech/",
            source: "https://github.com/humbertodutra/planets-project",
            stack: [react, nextjs, python, mysql],
            image: road2gold
        },
        {
            title: "Coletivo IA",
            live: "https://coletivoia.com/",
            source: "https://github.com/humbertodutra/trybe-project-wallet",
            image: coletivoIa,
            stack: [nextjs, react, mysql],
        },
        {
            title: "Green River IT",
            live: "https://www.greenriverit.tech/",
            source: "https://github.com/humbertodutra/trybe-project-tryunfo",
            image: greenriver,
            stack: [nextjs, react],
        }
    ],
    portfolioWorkingOn: [
        {
            title: "GiveBack",
            live: "https://giveback.co.il/",
            source: "",
            image: giveback,
            stack: [react, typescript, nodejs],
        },
        {
            title: "Headstart",
            live: "https://headstart.co.il/",
            source: "",
            image: headstart,
            stack: [react, typescript, nodejs],
        },
        {
            title: "BeActive",
            live: "https://beactive.co.il/",
            source: "",
            image: beactive,
            stack: [react, typescript, nodejs],
        },
        {
            title: "Fundit Invest",
            live: "https://invest.fundit.co.il/",
            source: "",
            image: fundit,
            stack: [react, typescript, nodejs],
        },
        {
            title: "Bembos",
            live: "https://apps.apple.com/pe/app/bembos/id952866349",
            source: "",
            image: bembos,
            stack: [react, typescript],
        },
    ],
    portfolio: [
        {
            title: "Planets Project",
            live: "https://humbertodutra.github.io/planets-project/",
            source: "https://github.com/humbertodutra/planets-project",
            stack: [react, css, api],
            image: planet
        },
        
        {
            title: "Trybe Wallet",
            live: "https://humbertodutra.github.io/trybe-project-wallet/",
            source: "https://github.com/humbertodutra/trybe-project-wallet",
            image: wallet,
            stack: [react, redux, css, api],
        },
        {
            title: "Trivia Game",
            live: "https://humbertodutra.github.io/trybe-project-trivia/#/",
            source: "https://github.com/humbertodutra/trybe-project-trivia/",
            image: triviaImg,
            stack: [react, css, api, redux],
        },
        {
            title: "Project Tryunfo",
            live: "https://humbertodutra.github.io/trybe-project-tryunfo/",
            source: "https://github.com/humbertodutra/trybe-project-tryunfo",
            image: tryunfoImg,
            stack: [react, css ],
        },
       
        {
            title: "Trybe Tunes",
            live: "https://humbertodutra.github.io/trybe-tunes",
            source: "https://github.com/humbertodutra/trybe-tunes",
            image: trybeTunes,
            stack: [react, css, api],
        },
        {
            title: "Trybe Online Store",
            live: "https://humbertodutra.github.io/trybe-online-store-17/#/",
            source: "https://github.com/humbertodutra/trybe-online-store-17/",
            image: trybeOnlineStore,
            stack: [react, css, api],
        },
        {
            title: "Food Station App",
            live: "https://humbertodutra.github.io/trybe-project-recipes-app/#/",
            source: "https://github.com/humbertodutra/trybe-project-recipes-app",
            image:  recipeApp,
            stack: [react, css, api],
        },
        {
            title: "Pixel Art",
            live: "https://humbertodutra.github.io/trybe-pixel-art/",
            source: "https://github.com/humbertodutra/trybe-pixel-art/",
            image: pixelArt,
            stack: [html, css, js],
        }
    ],
    portfolioBackend: [
        {
            title: "Delivery App",
            live: "",
            source: "https://github.com/humbertodutra/project-delivery-app",
            image:  '',
            stack: [react, mongoDb, js, typescript, sequelize, nodejs, JWT, api],
        },
        {
            title: "Trybe Football Club",
            live: "",
            source: "https://github.com/humbertodutra/Trybe-Project-Football-club",
            image: "",
            stack: [react, docker, typescript, nodejs, mysql, JWT, sequelize, jest, mocha],
        },
        {
            title: "Store Manager",
            live: "",
            source: "https://github.com/humbertodutra/Trybe-project-storeManager",
            stack: [docker, nodejs, mysql],
            image: ""
        },
        
        {
            title: "Blogs Api",
            live: "",
            source: "https://github.com/humbertodutra/Trybe-project-blogsApi",
            image: "",
            stack: [docker, nodejs, mysql, sequelize, JWT],
        },
        {
            title: "Stranger Things",
            live: "",
            source: "https://github.com/humbertodutra/Trybe-project-strangerThings-backend",
            image: "",
            stack: [heroku, docker, nodejs, mysql]
        },
        {
            title: "Project TrybeSmith",
            live: "",
            source: "https://github.com/humbertodutra/Trybe-project-trybeSmith",
            image: "",
            stack: [docker, typescript, nodejs, mysql, JWT],
        },
        {
            title: "Car-Shop",
            live: "",
            source: "https://github.com/humbertodutra/Project-carShop",
            image:  '',
            stack: [mongoDb, typescript, nodejs],
        },
     
        {
            title: "Trybers and Dragons",
            live: "",
            source: "https://github.com/humbertodutra/Trybe-project-trybersAndDragons",
            image:  '',
            stack: [nodejs, docker, typescript],
        },
        {
            title: "Trybe Inventory Report",
            live: "",
            source: "https://github.com/humbertodutra/trybe-invetory-report",
            image: '',
            stack: [python],
        },
        {
            title: "Project Algorithms",
            live: "",
            source: "https://github.com/humbertodutra/project-alorithms",
            image:  '',
            stack: [python],
        },
        {
            title: "Project Jobs Insights",
            live: "",
            source: "https://github.com/humbertodutra/project-job-insights",
            image:  '',
            stack: [python],
        },
        {
            title: "Project Ting",
            live: "",
            source: "https://github.com/humbertodutra/project-ting",
            image:  '',
            stack: [python],
        },
        {
            title: "Project Restaurant Order",
            live: "",
            source: "https://github.com/humbertodutra/project-restaurant-order",
            image:  '',
            stack: [python],
        },
        {
            title: "Project Tech News",
            live: "",
            source: "https://github.com/humbertodutra/project-tech-news",
            image:  '',
            stack: [python],
        },
    ],


    Languages: [
        {
            label: 'Portuguese',
            emoji: '🇧🇷',
            level: 'Native'
        },
        {
            label: 'English',
            emoji: '🇺🇸',
            level: 'Advanced',
        },
        {
            label: 'Spanish',
            emoji: '🇪🇸',
            level: 'Advanced',
        }
        
    ]

    }
